<template>
  <div class="about">
    <h1>SDK-test</h1>
    <video
      id="webcam"
      style="width:300px;height:300px;"
      autoPlay
      playsInline
    ></video>
    <div class="command-wrap" style="display: flex;flex-wrap: wrap">
      <Command
        v-for="(item, index) in list"
        :key="index"
        :name="item.name"
        :code.sync="item.code"
        :command="item.command"
      />
    </div>
  </div>
</template>
<script>
import Command from "../components/Command";
export default {
  name: "SDK测试",
  components: { Command },
  data() {
    return {
      list: [
        {
          code: `window.testaaa = new IM.CoolVideo({"socketUrl":"wss://voipconference.xfyun.cn:8082/","tag":"webcam","sessid":"23341b4ae4154ab1a3acfbe14e6f8216","videoParams":{"width":{"min":640,"ideal":1280,"max":1280},"height":{"min":480,"ideal":720,"max":720},"frameRate":{"min":20,"ideal":20,"max":30},"vertoBestFrameRate":20},"deviceParams":{"useCamera":"any","useMic":"any","useSpeak":"any"}})`,
          command: `CoolVideo`,
          name: "初始化组件",
          description: "初始化视频组件， 需要在video标签"
        },
        {
          code: `testaaa.newCall({"destination_number":"3420110189","caller_id_name":"wangke","caller_id_number":"23341b4ae4154ab1a3acfbe14e6f8216","useCamera":"any","useMic":"any","useSpeak":"any","userVariables":{"userName":"wangke","userType":"1","userId":"23341b4ae4154ab1a3acfbe14e6f8216"}})`,
          command: `CoolVideo.newCall`,
          name: "开始语音"
        },
        {
          code: ``,
          command: `beforeCloseVideo`,
          name: "钩子函数， 用于在关闭视频之前调用"
        },
        {
          code: ``,
          command: `beforeFinish`,
          name: ""
        },
        {
          code: ``,
          command: `beforeOpenVideo`,
          name: ""
        },
        {
          code: ``,
          command: `beforeShareScreen`,
          name: ""
        },
        {
          code: `IM.beforeStart('5c3e4d5526984a5580f318d49c635eb3')`,
          command: `beforeStart`,
          name: "加入会议之前的回调"
        },
        {
          code: ``,
          command: `beforeStopShareScreen`,
          name: ""
        },
        {
          code: ``,
          command: `cancelMeeting`,
          name: ""
        },
        {
          code: ``,
          command: `editMeeting`,
          name: ""
        },
        {
          code: ``,
          command: `editUserInfo`,
          name: ""
        },
        {
          code: ``,
          command: `enumObj`,
          name: ""
        },
        {
          code: ``,
          command: `getApps`,
          name: ""
        },
        {
          code: `IM.delMeeting('5c3e4d5526984a5580f318d49c635eb3')`,
          command: "delMeeting",
          name: "取消会议"
        },
        {
          code: `IM.getMeetingInfo("5c3e4d5526984a5580f318d49c635eb3")`,
          command: `getMeetingInfo`,
          name: "获取会议信息"
        },
        {
          code: `IM.getMeetings({"userId":"23341b4ae4154ab1a3acfbe14e6f8216","topic":"","status":"0,10,11","scheduleStartTime":"1606234500","scheduleEndTime":"1606319999","isDelete":0})`,
          command: `getMeetings`,
          name: "获取所有会议"
        },
        {
          code: `IM.getRooms({"date":"2020-11-25"})`,
          command: `getRooms`,
          name: "获取会议室信息"
        },
        {
          code: `IM.getUserInfo("0078f855ddde42cca0bfde4017d98172")`,
          command: `getUserInfo`,
          name: "获取用户信息"
        },
        {
          code: `IM.getUsers({loginName: null})`,
          command: `getUsers`,
          name: "获取用户"
        },
        {
          code: ``,
          command: `joinMeeting`,
          name: ""
        },
        {
          code: ``,
          command: `login`,
          name: ""
        },
        {
          code: `IM.orderMeeting({"id":"","topic":"wangke预定的会议","roomId":"1","ip":"42.62.116.67","scheduleStartTime":parseInt(Date.now()/1000 + 1),"scheduleEndTime":parseInt(Date.now()/1000 + 2),"joinUsers":[{"userId":"23341b4ae4154ab1a3acfbe14e6f8216","userName":"wangke","userType":1}]})`,
          command: `orderMeeting`,
          name: "预定会议"
        },
        {
          code: ``,
          command: `register`,
          name: ""
        }
      ]
    };
  }
};
</script>
